import { render, staticRenderFns } from "./LookDetailsDialog.vue?vue&type=template&id=98e28946&scoped=true"
import script from "./LookDetailsDialog.vue?vue&type=script&lang=js"
export * from "./LookDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./LookDetailsDialog.vue?vue&type=style&index=0&id=98e28946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e28946",
  null
  
)

export default component.exports